import { DatePicker, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getAppInstallCount } from "../../api/statistics.api";
import Button from "../../components/Button";
import DownloadButton from "../../components/DownloadButton";
import ErrorResponse from "../../components/ErrorResponse";
//import Header from "../../components/layout/Header";
import Loader from "../../components/Loader";
import ScrollView from "../../components/payment/ScrollView";
import SelectCampus from "../../components/SelectCampus";
import useAxios from "../../hooks/useAxios";
import exportTable from "../../lib/exportTable";
import { IGetAppInstallCount } from "../../models/statistics.model";
import { RootState } from "../../store/rootReducer";
import StatDatePickerTable from "../../components/statistics/DatePickerTable";
import { DateTableType } from "../../constans";
import TableEmpty from "../../components/common/TableEmpty";

const StatisticsAppDay = () => {
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { data: res, isLoading, error, execute } = useAxios<IGetAppInstallCount>();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);

  const [campusCode, setCampusCode] = useState<string>("");
  const [srtDate, setSrtDate] = useState(moment().subtract(1, 'months').format('YYYYMMDD'));
  const [endDate, setEndDate] = useState(moment().format('YYYYMMDD'));
  const [defSelType, setDefSelType] = useState<number>(0);

  const onSearch = () => {
    const params: any = { srtDate, endDate};

    if (auth.hqYn === 'Y' && campusCode) {
      params.campusCode = campusCode;
    } else if (auth.hqYn === 'N' && currentCampus) {
      params.campusCode = currentCampus;
    }

    execute(getAppInstallCount(params));
  }
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (serverDate) {
      setSrtDate(moment(serverDate).format('YYYYMM01'));
      setEndDate(moment(serverDate).format('YYYYMMDD'));
    }
  }, [serverDate]);


  const onExportTable = () => {
    if (!res?.data?.installInfo) return;
    const currentDate = moment(new Date());
    exportTable(columns, res.data.installInfo, `${t('statistics.appDay.1')}_(${currentDate.format('YYYYMMDD')})`, t('statistics.appDay.1'), [15, 12, 12, 10]);
  }

  const columns = [
    {
      title: t('statistics.appday.column1'),
      dataIndex: 'installDate',
      key: 'installDate',
    },
    {
      title: 'Android',
      dataIndex: 'androidCount',
      key: 'androidCount',
    },
    {
      title: 'iOS',
      dataIndex: 'iosCount',
      key: 'iosCount',
    },
    {
      title: t('statistics.appday.column2'),
      dataIndex: 'dateTotalCount',
      key: 'dateTotalCount',
    },
  ];

  return (
    <div >
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
              <div>
                {auth.hqYn === 'Y' ? (
                  <SelectCampus
                    placeholder={t('class.class.placeholder1')}
                    value={campusCode}
                    onChange={(value: string) => setCampusCode(value)}
                    hasAll={true}
                  />
                  
                ) : (
                  <SelectCampus />
                )}
              </div>
            </li>
            <li className="period">
              <label>{t('sms.list.column1')}</label> {/* 기간 */}
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center">
                  <div className="date-picker__area">
                    <DatePicker
                      value={srtDate ? moment(srtDate) : undefined}
                      onChange={(e) => {
                        if (e === null) setSrtDate('');
                        else setSrtDate(moment(e).format('YYYYMMDD'));
                        setDefSelType(0);
                      }}
                      format={['YYYY-MM-DD', 'YYYYMMDD']}
                    />
                    ~
                    <DatePicker
                      value={endDate ? moment(endDate) : undefined}
                      onChange={(e) => {
                        if (e === null) setEndDate('');
                        else setEndDate(moment(e).format('YYYYMMDD'));
                        setDefSelType(0);
                      }}
                      format={['YYYY-MM-DD', 'YYYYMMDD']}
                    />
                  </div>
                  <div className="comm-btn__area">
                    <Button
                      className="btn-basic small black"
                      onClick={onSearch}
                      text={t('common.button.search')}
                    />
                  </div>
                </div>
                <div className="comm-btn__area mt-2">
                  <StatDatePickerTable
                    setStartDate={setSrtDate}
                    setEndDate={setEndDate}
                    type={DateTableType.Simple}
                    defSelType={defSelType}
                    setDefSelType={setDefSelType}
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>	

      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      {
        res?.data
          ? (
            <>
              <div className="comm-table__area">
                <table>
                  <colgroup>
                    <col width="25%" />
                    <col width="25%" />
                    <col width="25%" />
                    <col width="25%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>{t('statistics.appday.column1')}</th>
                      <th>Android</th>
                      <th>iOS</th>
                      <th>{t('statistics.appday.column2')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {res.data.installInfo?.map(item => (
                      <tr>
                        <td>{moment(item.installDate).format('YYYY.MM.DD')}</td>
                        <td>{item.androidCount}</td>
                        <td>{item.iosCount}</td>
                        <td>{item.dateTotalCount}</td>
                      </tr>
                    ))}
                    
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={3}>{t('statistics.appday.column2')}</td>
                      <td>{res.data.totalCount}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="comm-bx__between">
                <DownloadButton onClick={onExportTable} />
              </div>
            </>
            )
          : (
            <TableEmpty text={t('statistics.appday.text1')} />
            )
      }
    </div>
  );
}

export default StatisticsAppDay;
